import { Typography } from '@mui/material';
import LegalPage from '../../components/common/LegalPage';

// Content from New Website.docx, "Page Title 'Cherry Creek Mortgage, LLC Data Partners'".
export default function DataPartners() {
  return (
    <LegalPage title="Cherry Creek Mortgage, LLC Data Partners">
      <Typography variant="body1">
        At Cherry Creek Mortgage, LLC, we are committed to providing a secure and streamlined digital mortgage
        experience. To simplify the application process, we may offer options that allow you to securely connect
        your bank accounts and employment information so we can verify financial and income details
        electronically—without requiring traditional paper documentation. To support this experience, we work
        with trusted third-party data partners that assist with verifying assets, income, employment, and credit
        information related to your mortgage application.
      </Typography>

      <Typography variant="h5">How Information Is Shared</Typography>
      <Typography variant="body1">
        By using our digital mortgage application, you acknowledge and consent to the sharing of certain personal
        information with our authorized data partners for legitimate business and underwriting purposes.
        Information shared with data partners may include, but is not limited to: full name, date of birth,
        address, telephone number, or Social Security number. Furthermore, with your authorization, our data
        partners may access financial account information to verify assets and income, or employment records to
        verify employment status and income. This information is used solely to support the mortgage loan process
        and related compliance obligations.
      </Typography>

      <Typography variant="h5">Ongoing Access and Data Refresh</Typography>
      <Typography variant="body1">
        To ensure accuracy while your loan is in process, account and employment information may be refreshed
        periodically. If your mortgage loan is completed, Cherry Creek Mortgage, LLC may retain your information
        in accordance with applicable legal and regulatory record-retention requirements (typically up to seven
        (7) years after your most recent loan activity). If your loan application is withdrawn or not approved,
        retention periods may be shorter, as permitted by law.
      </Typography>

      <Typography variant="h5">Managing Your Consent</Typography>
      <Typography variant="body1">
        You may change or revoke your consent to ongoing access at any time. If consent is revoked, we will no
        longer access your connected accounts or employment sources, and information already collected will be
        retained as part of your loan record, as required or permitted by law. To update your consent preferences,
        please see the form referenced in the &ldquo;Exercising Your California Privacy Rights&rdquo; section of
        our California Consumer Privacy Policy.
      </Typography>

      <Typography variant="h5">Data Partners</Typography>
      <Typography variant="body1">Cherry Creek Mortgage, LLC works with the following data partners, which may include but are not limited to:</Typography>
      <Typography variant="body1" component="ul">
        <li>SimpleNexus</li>
        <li>The Work Number</li>
        <li>Certified Credit</li>
        <li>Fannie Mae</li>
        <li>Freddie Mac</li>
        <li>Optimal Blue</li>
        <li>FHA/Ginnie Mae/U.S. Department of Housing and Urban Development</li>
      </Typography>
      <Typography variant="body1">
        Use of these partners is subject to their respective privacy and security practices, as well as
        applicable federal and state laws.
      </Typography>
    </LegalPage>
  );
}
